import { createFileRoute } from '@tanstack/react-router'
import { ProcessData } from 'pages/processData/ProcessData'
import { processDataDashboardSearchSchema } from 'routes/process-data/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <ProcessData orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/process-data/')({
  component: RouteComponent,
  validateSearch: processDataDashboardSearchSchema,
  staticData: {
    title: 'Process Data',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
